import { render, staticRenderFns } from "./ModuleExpand.vue?vue&type=template&id=8ecd0b98&"
import script from "./ModuleExpand.vue?vue&type=script&lang=js&"
export * from "./ModuleExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports